export * from './alert.component';


// WEBPACK FOOTER //
// ./src/app/_directives/index.ts